import * as React from "react";
import { useState } from "react";
import Loader from "./Loader";

interface IProps {
  url: string;
  width?: string;
  height?: string;
  office?: boolean;
}

const msOfficeEmbedUrl = "https://docs.google.com/viewer?embedded=true&url=";

function DocumentViewer({ url, width, height, office }: IProps) {
  const [loading, setLoading] = useState(true);

  if (office) {
    url = msOfficeEmbedUrl + encodeURIComponent(url);
  }

  return (
    <div>
      {loading && <Loader fullPageOverlay={true} size={"5em"} />}
      <iframe
        onLoad={() => setLoading(false)}
        src={url}
        width={width || "100%"}
        height={height || "800px"}
      />
    </div>
  );
}

export default DocumentViewer;



// WEBPACK FOOTER //
// ./app/javascript/components/core/DocumentViewer2.tsx